module.exports = __webpack_public_path__ + "zvetseni-prsou_50_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_50_before.jpg
// module id = 1346
// module chunks = 0